/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithSkuItemRequestBuilder, WithSkuItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products/deactivate
 */
export interface DeactivateRequestBuilder extends BaseRequestBuilder<DeactivateRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.products.deactivate.item collection
     * @param sku Unique identifier of the item
     * @returns {WithSkuItemRequestBuilder}
     */
     bySku(sku: string) : WithSkuItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DeactivateRequestBuilderUriTemplate = "{+baseurl}/api/products/deactivate";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DeactivateRequestBuilderNavigationMetadata: Record<Exclude<keyof DeactivateRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySku: {
        requestsMetadata: WithSkuItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["sku"],
    },
};
/* tslint:enable */
/* eslint-enable */
